/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStairsDown = createReactComponent("stairs-down", "IconStairsDown", [
  ["path", { d: "M22 21h-5v-5h-5v-5h-5v-5h-5", key: "svg-0" }],
  ["path", { d: "M18 3v7", key: "svg-1" }],
  ["path", { d: "M15 7l3 3l3 -3", key: "svg-2" }]
]);

export { IconStairsDown as default };
//# sourceMappingURL=IconStairsDown.js.map
